__turbopack_context__.v({
  "icon": "Icon-module-scss-module__Qto7ga__icon",
});
